<template>
  <Cleave
    :options="cleave.options"
    v-model="updateTo"
    @blur="$emit('input', updateTo)"
  />
</template>

<script>
import Cleave from 'vue-cleave-component';

export default {
  components: {
    Cleave,
  },

  props: {
    value: {
      default: null,
    },
    type: {
      default: 'decimal',
      required: false,
    },
    options: {
      default: null,
      required: false,
    },
  },

  created () {
    if (this.$lang().getLocale() === "pt_BR") {
      this.cleave.options = {
        ...this.cleave.options,
        delimiter: '.',
        numeralDecimalMark: ',',
      };
    }
  },

  data () {
    return {
      updateTo: this.value,
      cleave: {
        types: this.type,
        options: {
          numeral: true,
          delimiter: ',',
          numeralDecimalMark: '.',
          numeralPositiveOnly: true,
          numeralDecimalScale: 2,
        },
      },
    };
  },
};
</script>
